var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Web-Copy-6",
    transform: "translate(-1058.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-7",
    transform: "translate(1058.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.23913,115.478261 C121.14888,115.478261 136.478261,100.14888 136.478261,81.2391304 C136.478261,62.3293808 121.14888,47 102.23913,47 C83.3293808,47 68,62.3293808 68,81.2391304 C68,85.9105719 68,99.4975284 68,122 L81.0434783,115.478261 C91.1132133,115.478261 98.1784307,115.478261 102.23913,115.478261 Z",
    id: "Oval",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.23913,102.478261 C121.14888,102.478261 136.478261,87.14888 136.478261,68.2391304 C136.478261,49.3293808 121.14888,34 102.23913,34 C83.3293808,34 68,49.3293808 68,68.2391304 C68,72.9105719 68,86.4975284 68,109 L81.0434783,102.478261 C91.1132133,102.478261 98.1784307,102.478261 102.23913,102.478261 Z",
    id: "Oval",
    stroke: "#000000",
    transform: "translate(102.239130, 71.500000) scale(-1, 1) translate(-102.239130, -71.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(103.239130, 75.500000) scale(-1, 1) translate(-103.239130, -75.500000) translate(57.726087, 49.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1130435,43.826087 C81.2152832,43.826087 91.026087,34.0152832 91.026087,21.9130435 C91.026087,9.81080374 81.2152832,0 69.1130435,0 C57.0108037,0 47.2,9.81080374 47.2,21.9130435 C47.2,24.902766 47.2,33.5984182 47.2,48 L55.5478261,43.826087 C61.9924565,43.826087 66.5141956,43.826087 69.1130435,43.826087 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9130435,48.826087 C34.0152832,48.826087 43.826087,39.0152832 43.826087,26.9130435 C43.826087,14.8108037 34.0152832,5 21.9130435,5 C9.81080374,5 0,14.8108037 0,26.9130435 C0,29.902766 0,38.5984182 0,53 L8.34782609,48.826087 C14.7924565,48.826087 19.3141956,48.826087 21.9130435,48.826087 Z",
    id: "Oval",
    transform: "translate(21.913043, 29.000000) scale(-1, -1) translate(-21.913043, -29.000000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.9795491,106.109409 L51,87.5 L51,87.5 C47.6666667,82.6686199 46,79.0019533 46,76.5 C46,40.5 75.4135361,23.9995838 96.5,23.9995838 C131.5,23.9995838 151,44 156.5,59 C162,74 159.058273,99.1200949 147,107 C133.232318,115.996979 148.628405,134.673468 138.5,137.5 C125.158142,141.223309 112.971536,152.888981 101.940183,172.497014 L101.940182,172.497013 C101.398586,173.45969 100.179133,173.801044 99.2164562,173.259448 C98.7477635,172.995764 98.4050083,172.554441 98.2655364,172.035067 C95.0651037,160.117097 90.9765915,151.772074 86,147 C77.538405,138.886142 60.5474225,153.82268 54.5,140 C52.1666667,134.666667 51,125.5 51,112.5 L41.3960132,107.46934 C40.9067819,107.213076 40.7179246,106.608733 40.9741886,106.119502 C40.9759562,106.116127 40.977743,106.112763 40.9795491,106.109409 Z",
    id: "Path-5",
    stroke: "#000000",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.0103584bd3bd35e0be23b0f687a338a1.svg";
export { ForwardRef as ReactComponent };